import { useLocation } from 'react-router-dom';

import { Workflow } from '../../constants/Workflow';

export const useWorkflowPathname = (): Workflow => {
  const location = useLocation();

  return (/^\/([^/]+)/.exec(location.pathname)?.[1] || '') as Workflow;
};
